<template>
    <div class="spark-content-body-html" v-html="sanitizedHtml" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { sanitizeRichTextHtml } from '@/utils/htmlUtils.ts';

const props = defineProps<{
    html: string;
}>();

const sanitizedHtml = computed<string>(() => sanitizeRichTextHtml(props.html));
</script>

<style lang="scss">
.spark-content-body-html {
    line-height: 1.75;
}

.spark-content-body-html h1,
.spark-content-body-html h2,
.spark-content-body-html h3,
.spark-content-body-html h4,
.spark-content-body-html h5,
.spark-content-body-html h6 {
    margin-top: var(--largeSpacing);
    margin-bottom: var(--defaultSpacing);
}

.spark-content-body-html h1 {
    font-size: var(--extraLargeFontSize);
}

.spark-content-body-html h2 {
    font-size: var(--largeFontSize);
}

.spark-content-body-html h3,
.spark-content-body-html h4,
.spark-content-body-html h5,
.spark-content-body-html h6 {
    font-size: var(--defaultFontSize);
}

.spark-content-body-html p,
.spark-content-body-html ul,
.spark-content-body-html ol {
    margin-bottom: var(--defaultSpacing);
}

.spark-content-body-html ul,
.spark-content-body-html ol {
    padding-left: var(--extraLargeSpacing);
}

.spark-content-body-html ul {
    list-style: disc;
}

.spark-content-body-html ol {
    list-style: decimal;
}

.spark-content-body-html li {
    margin-bottom: var(--smallSpacing);
}

.spark-content-body-html a {
    color: var(--accentColour);
}

.spark-content-body-html img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: var(--defaultSpacing) 0;
    border-radius: var(--borderRadiusInner);
}
</style>
